import styled from 'styled-components';
import { customMedia } from 'styles/utils';
import { BlockSize } from 'libs/rendering/gltf/config';

export const InputFileWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  // width: 100%;
  // max-width: 100vw;
  height: 100%;
  margin-left: 24px;
  margin-right: 24px;
  // margin: ${BlockSize.height} auto 0 auto;
  padding-top: ${props => props.paddingTop || '0px'};
  opacity: ${props => (props.disabled ? 0.4 : 1)};

  ${customMedia.greaterThan('xlarge')`
    min-height: calc(100vh - ${BlockSize.height});
  `};

  ${customMedia.between('small', 'xlarge')`
    min-height: ${props =>
      props.isSampleBannerOpen ? '120vh' : `calc(100vh - ${BlockSize.height})`};
  `};

  ${customMedia.lessThan('small')`
    min-height: ${props => (props.isSampleBannerOpen ? '180vh' : '140vh')};
  `};
`;

export const ActiveEventsWrapper = styled.div`
  pointer-events: auto;
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: ${props => props.theme.space[4]};
  //transform: scale(2.5);

  ${customMedia.lessThan('small')`
    margin: auto ${props => props.theme.spacing.xlarge} auto 0;
    // transform: scale(2);
  `};
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin: ${props => `${props.theme.spacing.default} auto`};

  ${customMedia.greaterThan('xxlarge')`
    margin: ${props =>
      props.isSampleBannerOpen
        ? `${props.theme.spacing.default} auto`
        : `${props.theme.spacing.default} auto 6rem auto`};
  `};
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  ${customMedia.lessThan('small')`
    max-width: 12rem;
  `};
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 66%;
  margin: ${props => props.theme.spacing.default} auto;
  border-top: 1px solid ${props => props.theme.color.wfGrey200};

  ${customMedia.greaterThan('xxlarge')`
    div > div {
      transform-origin: center center;
      transform: scale(1.4);
    }
  `};
`;
